import React, { useEffect, useState } from "react";
import "react-multi-carousel/lib/styles.css";
import { SidebarContextPrv } from "./Contexts/SidebarContext";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Outlet,
} from "react-router-dom";
import { router } from "./routing/routingmanger";
import axios from "axios";
import { setLanguage } from "./utils/message";
import { LocalStorageUtil } from "./utils/LocalStorageUtil";
import GoogleScriptLoader from "./components/maps/GoogleScriptLoader";
// @ts-ignore
import TagManager from "react-gtm-module";

const theme = createTheme({
  typography: {
    fontSize: 12,

    fontFamily: [
      "Poppins",
      // "Roboto",
      // "Helvetica Neue",
      // "Arial",
      "sans-serif",
    ].join(","),
  },
  components: {
    // Name of the component
    MuiDialogActions: {
      styleOverrides: {
        root: {
          "& .MuiButtonBase-root": {
            paddingTop: "8px",
            paddingBottom: "8px",
            color: "#fff",
            background: "#3b67ff",
            borderColor: "#3b67ff",
            "&:hover": {
              backgroundColor: "#001c81",
              borderColor: "#001c81",
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          boxShadow: "0px 0px 0px 1px rgb(140 140 140/.2)",
        },
      },
    },
    MuiTextField: {
      // defaultProps: {
      //   // size: 'small' as 'small' | 'medium',
      //   height: "50px",
      // },
      defaultProps: {
        // autoComplete: 'off',
        autoComplete: "ViewCrunch",
      },
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            height: "40px",
            display: "flex",
            alignItems: "center",
          },

          "& .MuiInputBase-input": {
            padding: 0,
            paddingLeft: "14px", // Adjust padding as needed
            height: "100%",
            boxSizing: "border-box",
          },
          "& .MuiFormLabel-root": {
            height: "40px",
            lineHeight: "12px",
            // marginTop:"-5px"
          },
          "& .MuiInputLabel-root": {
            height: "15px",
            lineHeight: "12px",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiAutocomplete-inputRoot": {
            height: "40px",
            display: "flex",
            alignItems: "center",
            overflowY: "auto",
            background: "#fff",
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        // root: {
        //   "& .MuiInputBase-root": {
        //     height: "40px",
        //     display: "flex",
        //     alignItems: "center",
        //   },
        //   "& .MuiInputBase-input": {
        //     padding: 0,
        //     paddingLeft: "14px",
        //     height: "100%",
        //     boxSizing: "border-box",
        //   },
        //   "& .MuiFormLabel-root": {
        //     height: "40px",
        //     lineHeight: "12px",
        //   },
        // },
      },
    },
  },
});

function App() {
  const [loading, setLoading] = useState(true);
  const [tabId] = useState(() => {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return "tab_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
  });

  useEffect(() => {
    // Create independent session for this tab
    const createTabSession = () => {
      sessionStorage.setItem("tabId", tabId);

      // Copy data from localStorage to sessionStorage for this tab
      const lastLoginKey = localStorage.getItem("lastLoginKey");
      if (lastLoginKey && !sessionStorage.getItem("lastLoginKey")) {
        sessionStorage.setItem("lastLoginKey", lastLoginKey);
        const userData = localStorage.getItem(lastLoginKey);
        if (userData) {
          sessionStorage.setItem(lastLoginKey, userData);
          LocalStorageUtil.ldataKey = lastLoginKey;
        }
      }
    };

    createTabSession();
    clearBrowserCache();
    loadServerandKeys();

    const handleBeforeUnload = () => {
      LocalStorageUtil.copySessionToLocal();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [tabId]);

  const loadServerandKeys = async () => {
    let mili = new Date().getTime();
    const res = await axios.get(`../server.json?rand=${mili}`);
    try {
      LocalStorageUtil.setBaseURL(res.data.servers.server.url);
      LocalStorageUtil.setGKey(res.data.servers.server.gMapKey);
      LocalStorageUtil.setTagId(res.data.servers.server.googleTagId);
      TagManager.initialize({
        gtmId: res?.data?.servers?.server?.googleTagId || "",
      });
    } catch (e) {
      LocalStorageUtil.setBaseURL("http://54.226.131.201:8080");
      LocalStorageUtil.setGKey("AIzaSyC7SVyTtsbfDk7h7tjArGgNDnunO-ErGCw");
    }
    setLoading(false);
    GoogleScriptLoader();
  };

  const loadLanguages = async () => {
    let mili = new Date().getTime();
    const res = await axios.get(`../language.json?rand=${mili}`);
    setLanguage(res.data);
  };

  let clearBrowserCache = () => {
    if ("caches" in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });

      // Makes sure the page reloads. Changes are only visible after you refresh.
      // window.location.reload();
    }
  };

  if (loading) return <>Loading...</>;

  return (
    <>
      <link href="./assets/css/finpark.css" rel="stylesheet" type="text/css" />
      <div className="App">
        <ThemeProvider theme={theme}>
          <SidebarContextPrv>
            <RouterProvider router={router} />
          </SidebarContextPrv>
        </ThemeProvider>
      </div>
    </>
  );
}

export default App;
